import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import FundingTrackerPage from "@/pages/admin/FundingTrackerPage";

export const Route = createFileRoute("/_admin/admin/funding-tracker")({
  head: () => pageHead("Admin · Funding Tracker", "AKIVA admin · funding tracker portal.", "/admin/funding-tracker", true),
  component: FundingTrackerPage,
});
